<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <inquiry-details
            :inquiry='inquiry'
            v-if='inquiry'
            @update='update'
          ></inquiry-details>
        </v-col>
        <v-col cols='12' md='4'>
          <site
            :inquiry='inquiry'
            v-if='inquiry'
            @update='update'
          ></site>
          <assigned-to
            class='mt-6'
            :inquiry='inquiry'
            v-if='inquiry'
            @update='update'
          ></assigned-to>
        </v-col>
        <v-col cols='12' md='4'>
          <contact
            :inquiry='inquiry'
            v-if='inquiry'
            @update='update'
          ></contact>
        </v-col>
        <v-col cols='12'>
          <wc-data-box
            title='Initial Conversation'
            :titleIcon='icon'
            titleIconColor='purple'
            showEdit
            @edit='editNotes'
          >
            <v-card-text>
              <span v-if='!inquiry.notes'>None...</span>
              <span>{{ inquiry.notes }}</span>
            </v-card-text>
          </wc-data-box>

          <wc-dialog
            title='Initial Conversation'
            :icon='icon'
            :showDialog='showDialog'
            @cancel='showDialog = false'
            @save='saveNotes'
          >
            <v-textarea outlined auto-grow v-model='inquiryCopy.notes'></v-textarea>
          </wc-dialog>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AssignedTo from './AssignedTo'
import InquiryDetails from './Details'
import Contact from './Contact'
import Site from './Site'
import _ from 'lodash'

export default {
  name: 'inquiries-dashboard',
  data: () => ({
    isLoading: true,
    showDialog: false,
    inquiryCopy: {},
    icon: 'mdi-forum'
  }),
  props: {
    inquiry: {
      required: true
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.isLoading = false
    },
    editNotes () {
      this.inquiryCopy = _.cloneDeep(this.inquiry)
      this.showDialog = true
    },
    saveNotes () {
      this.update(this.inquiryCopy)
      this.showDialog = false
    },
    update (obj) {
      this.$emit('update', obj)
    }
  },
  components: {
    'inquiry-details': InquiryDetails,
    'assigned-to': AssignedTo,
    'contact': Contact,
    'site': Site,
  }
}
</script>
